
const Console = {};
if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    Console.log = console.log.bind(console);
    // eslint-disable-next-line no-console
    Console.info = console.info.bind(console);
    // eslint-disable-next-line no-console
    Console.warn = console.warn.bind(console);
    // eslint-disable-next-line no-console
    Console.error = console.error.bind(console);
    // eslint-disable-next-line no-console
    Console.debug = console.debug.bind(console);
    // eslint-disable-next-line no-console
    Console.assert = console.assert.bind(console);
    // eslint-disable-next-line no-console
    Console.trace = console.trace.bind(console);
} else {
    const noop = function() {};
    Console.log = noop;
    Console.info = noop;
    Console.warn = noop;
    Console.error = noop;
    Console.debug = noop;
    Console.assert = noop;
    Console.trace = noop;
}

export default Console;
